import { Field } from 'module/api/field/types';
import {
  TextFieldFilter,
  TextFieldFilterOperationType,
} from 'module/types/filter-field/filter/text';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';
import { getFieldValue } from './get-field-value';

export const text = (filter: TextFieldFilter): FilterFunction => {
  const value = getFieldValue<string>(filter.field as any as Field);

  switch (filter.type) {
    case TextFieldFilterOperationType.IsEmpty:
      return (record) => value(record) == null || value(record) === '';
    case TextFieldFilterOperationType.IsNotEmpty:
      return (record) => value(record) != null && value(record) !== '';
    case TextFieldFilterOperationType.Contains:
      return (record) =>
        ((value(record) as string | undefined) ?? '')
          .toLowerCase()
          .includes(filter.value!.toLowerCase()) ?? false;
    case TextFieldFilterOperationType.DoesNotContain:
      return (record) =>
        !((value(record) as string | undefined) || '')
          .toLowerCase()
          .includes(filter.value!.toLowerCase());
    default:
      return () => true;
  }
};
